// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@keyframes shimmer-loading--UghMV{0%{background-position:200% 0}100%{background-position:-200% 0}}.image-select .react-select__indicator{padding:6px 10px}.image-select .react-select__placeholder{color:#96a0b4;font-size:.875rem;font-weight:400;line-height:1.25rem;letter-spacing:.02em}.image-select img{-o-object-fit:contain;object-fit:contain;margin-right:10px;width:24px;height:24px}.image-select.is-disabled>.Select-control .Select-value .Select-value-label{color:#b4bccd;font-style:italic}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"shimmer-loading": "shimmer-loading--UghMV"
};
export default ___CSS_LOADER_EXPORT___;
